import * as React from 'react';
import { ui, HeaderLink } from 'web-shared/store';

export function useHeaderLinks(links: HeaderLink[]) {
    React.useEffect(() => {
        ui.setHeaderLinks({ links, hideLogin: false });
    }, []);
}
